<template>
    <BOrchestrator />
    <div id="app">
        <router-view name="header"></router-view>
        <main>
            <router-view v-slot="{ Component }">
                <transition name="fade" origin="center" mode="out-in" :duration="250">
                    <component :is="Component" />
                </transition>
            </router-view>
        </main>
        <router-view name="footer"></router-view>
    </div>
</template>
<script>
import { useRouter } from "vue-router";
import { useHead } from '@vueuse/head'
import { BOrchestrator } from 'bootstrap-vue-next'

export default {
  components: {BOrchestrator},
  setup() {
    const router = useRouter();
    useHead({
      meta: [
        { property: 'og:url', content: location.origin + router.currentRoute.value.path },
        { property: 'og:site_name', content: '雛菊書房' },
        { property: 'twitter:site', content: '@HinagikuBooks' }
      ]
    })
  },
};
</script>
